export const classes = [
  {
    class: "ASA 1",
    definition: "A normal healthy person",
    examples: "Healthy, non-smoking, no or minimal alcohol use",
  },
  {
    class: "ASA II",
    definition: "A patient with mild systemic disease",
    examples:
      "Mild diseases only without substantive functional limitations. Current smoker, social alcohol drinker, pregnancy, obesity (30<BMI<40), well-controlled DM/HTN, mild lung disease",
  },
  {
    class: "ASA III",
    definition: "A patient with severe systemic disease",
    examples:
      "Substantive functional limitations; One or more moderate to severe diseases. Poorly controlled DM or HTN, COPD, morbid obesity (BMI ≥40), active hepatitis, alcohol dependence or abuse, implanted pacemaker, moderate reduction of ejection fraction, ESRD undergoing regularly scheduled dialysis, history (>3 months) of MI, CVA, TIA, or CAD/stents.",
  },
  {
    class: "ASA IV",
    definition:
      "A patient with severe systemic disease that is a constant threat to life",
    examples:
      "Recent (<3 months) MI, CVA, TIA or CAD/stents, ongoing cardiac ischemia or severe valve dysfunction, severe reduction of ejection fraction, shock, sepsis, DIC, ARD or ESRD not undergoing regularly scheduled dialys",
  },
  {
    class: "ASA V",
    definition:
      "A moribund patient who is not expected to survive without the operation",
    examples:
      "Ruptured abdominal/thoracic aneurysm, massive trauma, intracranial bleed with mass effect, ischemic bowel in the face of significant cardiac pathology or multiple organ/system dysfunction",
  },

  {
    class: "ASA VI",
    definition:
      "A declared brain-dead patient whose organs are being removed for donor purposes",
    examples: "",
  },
  {
    class: "ASA E",
    definition:
      "The addition of “E” denotes Emergency surgery. An emergency is defined as existing when delay in treatment of the patient would lead to a significant increase in the threat to life or body part.",
    examples: "",
  },
];
